import React from 'react'
import classNames from 'classnames'
import './AttachmentListItem.less'
import { Attachment } from '../../types/dataMatched'
import { OutlinedEditDrag } from '@hose/eui-icons'
import PreImg from '../FlowResult/PreImg'

export interface AttachmentListItemProps {
  className?: string
  dataSource: Attachment
  isDraggable?: boolean
  dragHandleProps?: any
  dragAttributes?: any
  dragListeners?: any
  isDragging?: boolean
  dragHandleRef?: any
}

export const AttachmentListItem: React.FC<AttachmentListItemProps> = (props) => {
  const {
    className,
    dataSource,
    isDraggable = false,
    dragHandleProps,
    dragAttributes,
    dragListeners,
    isDragging = false,
    dragHandleRef
  } = props

  return (
    <div
      className={classNames(
        'attachment-list-item',
        className,
        { 'is-dragging': isDragging }
      )}
      {...dragAttributes}
      data-draggable={isDraggable}
    >
      <OutlinedEditDrag
        ref={isDraggable ? dragHandleRef : undefined}
        fontSize={16}
        color='var(--eui-icon-n2, rgba(29, 33, 41, 0.60))'
        className={classNames(
          'attachment-list-item-icon',
          { 'drag-handle': isDraggable }
        )}
        {...(isDraggable ? dragHandleProps : {})}
        {...(isDraggable ? dragListeners : {})}
        onTouchStart={(e) => {
          // 阻止移动端文本选择，确保拖拽正常
          if (isDraggable) {
            e.preventDefault();
          }
        }}
      />
      <PreImg file={{
          key: dataSource.fileKey,
          url: dataSource.fileUrl,
          ...dataSource,
        }} size={16} className='attachment-list-item-icon-img'/>
      <span>{dataSource.fileName}</span>
    </div>
  )
}

export default AttachmentListItem